/* Selección inteligente de variantes · LEVIOHOME
   Si al elegir una opción la combinación no existe, se ajustan las demás opciones
   a la variante existente más parecida, para que siempre cambie foto y precio. */
(function () {
  function readVariants(container) {
    var el = container.querySelector('script[data-lv-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function position(input) {
    var m = /-(\d+)\s*$/.exec(input.name || '');
    return m ? parseInt(m[1], 10) - 1 : -1;
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      var container = t.closest('variant-selects');
      if (!container) return;
      var variants = readVariants(container);
      if (!variants) return;
      var k = position(t);
      if (k < 0) return;

      var radios = Array.prototype.slice.call(container.querySelectorAll('input[type=radio]'));
      var current = [];
      radios.forEach(function (r) {
        var p = position(r);
        if (p >= 0 && r.checked) current[p] = r.value;
      });
      current[k] = t.value;

      // ¿ya existe esa combinación exacta? entonces no hay nada que ajustar
      var exact = variants.filter(function (v) {
        return v.o.every(function (val, i) {
          return val === current[i];
        });
      });
      if (exact.length) return;

      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (v.o[k] !== t.value) return;
        var score = 0;
        v.o.forEach(function (val, i) {
          if (i !== k && val === current[i]) score++;
        });
        score = score * 2 + (v.a ? 1 : 0);
        if (score > bestScore) {
          best = v;
          bestScore = score;
        }
      });
      if (!best) return;

      radios.forEach(function (r) {
        var p = position(r);
        if (p < 0) return;
        r.checked = r.value === best.o[p];
      });
    },
    true
  );
})();
